import { useTranslation } from 'react-i18next';

const DETAILS = [
  { key: 's4.d1', icon: 'ri-stack-line' },
  { key: 's4.d2', icon: 'ri-leaf-line' },
  { key: 's4.d3', icon: 'ri-lightbulb-line' },
  { key: 's4.d4', icon: 'ri-layout-5-line' },
  { key: 's4.d5', icon: 'ri-roadster-line' },
];

export default function ArchitectureSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-foreground-950 py-20 md:py-28">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 md:px-6 lg:grid-cols-2 lg:gap-16">
        <div className="reveal img-hover-zoom overflow-hidden rounded-lg border border-foreground-700/50 h-[480px] md:h-[560px]">
          <img
            src="https://storage.helloreaddy.io/project_files/23cbf37b-3b60-45d6-b458-2fbb3e9ec10a/35545f0c-6d26-4bc5-b7a3-cf94caa69886_compressed_3.webp"
            alt={t('s4.title1')}
            title={t('s4.title1')}
            className="h-full w-full object-cover object-center"
          />
        </div>

        <div className="reveal reveal-delay-1">
          <span className="mb-5 inline-block h-px w-12 bg-primary-500"></span>
          <h2 className="font-heading text-3xl leading-tight text-background-50 md:text-4xl lg:text-5xl">
            {t('s4.title1')}
            <span className="block text-primary-500">{t('s4.title2')}</span>
          </h2>

          <ul className="mt-8 flex flex-col gap-4">
            {DETAILS.map((detail) => (
              <li key={detail.key} className="flex items-center gap-4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-500/10 text-primary-400">
                  <i className={`${detail.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <span className="text-base text-background-100/85 md:text-lg">
                  {t(detail.key)}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}